module.exports = __webpack_public_path__ + "img/yarinin-suyu@3x.55d48e07.png";